import { useQuery } from '@tanstack/react-query';
import type { PublicProfile } from 'shared';
import { ApiError, api } from '../lib/api-client.js';

export function useProfile() {
  return useQuery({
    queryKey: ['profile'],
    queryFn: async () => {
      try {
        return await api.get<PublicProfile>('/api/profile');
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 60_000,
  });
}
